<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>运营管理</a-breadcrumb-item>
      <a-breadcrumb-item>会议投币管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="operate-div">
      <div>
        <a-button type="primary" class="create-btn" @click="toPath({ path: '/systemSetting/manage/createCoin' })">发起投币</a-button>
      </div>
      <div class="flex">
        <div class="flex center">
          <span class="gap-10">快捷筛选:</span>
        </div>
        <a-input-search @search="handleSearch" placeholder="按被投者搜索" v-model="icName" class="input-search" />
        <a-input-search @search="handleSearch" placeholder="按项目名称搜索" v-model="companyName" class="input-search" />
      </div>
    </div>
    <div class="manage-table">
      <a-table :columns="columns" :data-source="list" rowKey="id" :pagination="false" :scroll="{ x: 'max-content' }">
        <div class="custom-cell" slot="icUserName" slot-scope="text, record">
          <div class="custom-row" v-for="item in record.result" :key="item.id">
            <a-tooltip>
              <template slot="title">
                <div v-for="reason in obj2arr(item.reasonList)" :key="reason.key">{{ reason.key }}: {{ reason.count }}</div>
              </template>
              {{ item.userName }}
            </a-tooltip>
          </div>
        </div>
        <div class="custom-cell" slot="icCoinCount" slot-scope="text, record">
          <div class="custom-row" v-for="item in record.result" :key="item.id">
            {{ item.coinCount }}

            <a-tooltip v-if="!record.finish" placement="topLeft">
              <template slot="title">
                <span>投币进行中</span>
              </template>
              <a-icon type="clock-circle" class="waiting" />
              <!-- <a-icon type="hourglass" class="waiting"/> -->
            </a-tooltip>
          </div>
        </div>
      </a-table>
      <!-- 分页 -->
      <div class="pagination-buttom">
        <a-pagination
          v-if="total > pageSize"
          :total="total"
          :page-size="pageSize"
          @change="onChange"
          v-model="page"
          :show-total="total => `共有 ${total} 条数据`"
        >
        </a-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import { coinList } from '@/api/coin.js';
import moment from 'moment';
import { meetingCategoryMap, meetingGoalMap } from '@/utils/meeting.ts';

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      icName: '',
      companyName: ''
    };
  },
  computed: {
    columns() {
      let total = this.list.reduce((ac, current) => ac + current.coinCount, 0);
      let personTotal = 0;
      let userName = '';
      let isSingle = true;
      this.list.forEach(item => {
        item.result &&
          item.result.forEach(i => {
            personTotal += i.coinCount;
            if (!userName) {
              userName = i.userName;
            } else {
              if (userName !== i.userName) {
                isSingle = false;
              }
            }
          });
      });
      return [
        {
          title: '项目名称',
          key: 'companyName',
          dataIndex: 'companyName'
          // width: 160,
        },
        {
          title: '轮次',
          dataIndex: 'roundName',
          key: 'roundName',
          // width: 90,
          customRender: (value, row, index) => {
            const obj = {
              children: value + '轮',
              attrs: {}
            };
            return obj;
          }
        },
        {
          title: '上会分类',
          dataIndex: 'meetingCategory',
          key: 'meetingCategory',
          // width: 90,
          customRender: (value, row, index) => {
            const obj = {
              children: meetingCategoryMap[value],
              attrs: {}
            };
            return obj;
          }
        },
        {
          title: '上会目的',
          dataIndex: 'meetingGoal',
          // width: 120,
          key: 'meetingGoal',
          customRender: (value, row, index) => {
            const obj = {
              children: meetingGoalMap[value],
              attrs: {}
            };
            return obj;
          }
        },
        {
          title: '上会时间',
          dataIndex: 'meetingDate',
          key: 'meetingDate'
          // width: 90
        },
        {
          title: 'DL',
          dataIndex: 'dealLeadersName',
          key: 'dlName'
          // width: 80
        },
        {
          title: '赛道',
          dataIndex: 'sectorName',
          key: 'sectorName'
          // width: 80
        },
        {
          title: `共发币数(${total ? total : '-'})`,
          dataIndex: 'coinCount',
          key: 'coinCount'
          // width: 120
        },
        {
          title: `被投币者(${isSingle ? personTotal : '-'})`,
          key: 'icUserName',
          // width: 100,
          scopedSlots: {
            customRender: 'icUserName'
          }
        },
        {
          title: '得币数',
          key: 'icCoinCount',
          // width: 100,
          scopedSlots: {
            customRender: 'icCoinCount'
          }
        }
      ];
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    toPath(params) {
      this.$router.push(params);
    },
    obj2arr(obj) {
      let arr = [];
      for (let key in obj) {
        arr.push({ key: key, count: obj[key] });
      }
      return arr;
    },
    async getList() {
      try {
        this.data = [];
        let res = await coinList({
          page: this.page,
          pageSize: this.pageSize,
          companyName: this.companyName,
          userName: this.icName,
          id: this.$route.query.id
        });
        if (res.code === 200) {
          let list = res.data.list || [];
          this.list = list.map(i => {
            return {
              ...i,
              meetingDate: i.meetingDate ? moment(i.meetingDate * 1000).format('YYYY-MM') : '-',
              finish: moment(i.startTime)
                .add(24, 'hour')
                .isBefore(moment())
            };
          });
          this.total = res.data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    onChange(page, pageSize) {
      this.page = page;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.operate-div {
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  .create-btn {
    padding: 0px 10px;
  }
  .urge-btn {
    padding: 0px 10px;
    margin-left: 20px;
  }
  .operate-end {
    display: flex;
    justify-content: flex-end;
    width: auto;
  }
  .flex {
    display: flex;
    .filter-unselected {
      color: rgb(24, 144, 255);
      cursor: pointer;
    }
  }
  .center {
    align-items: center;
  }

  .input-search {
    width: 200px;
    margin-left: 10px;
  }
}
.manage-table {
  padding-top: 30px;
  .waiting {
    // color: #1890ff;
    color: rgba(0, 0, 0, 0.25);
    margin-left: 5px;
  }
  .custom-cell {
    margin: -16px -16px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    .custom-row {
      padding: 0 16px;
      min-height: 32px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:last-child {
        border: none;
      }
    }
  }

  .pagination-buttom {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
}
.create-body {
  padding: 0 20px;
  .body-info {
    padding-bottom: 15px;
    .body-item {
      width: 100px;
      text-align: right;
    }
    .padding-div {
      padding-top: 10px;
    }
  }
  .hr-style {
    border: 1px solid #e8e8e8;
  }
  .score-body {
    padding: 15px 0px;
    display: flex;
    .item {
      width: 100px;
      text-align: right;
    }
    .score-item {
      padding-bottom: 10px;
      display: flex;
      .scorer {
        width: 65px;
      }
      .scored {
        width: 80px;
      }
    }
    .delete-icon {
      margin-left: 30px;
      color: @red;
      cursor: pointer;
    }
  }
  .explanation {
    padding-top: 30px;
    margin-bottom: -20px;
    display: flex;
    justify-content: flex-end;
  }
}
.flex {
  display: flex;
}
.pointer {
  cursor: pointer;
}
</style>
